export {MeoCloudHTTPMapping as default};

/**
* Meo Cloud HTTP Mapping
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MeoCloudHTTPMapping {
  /**
   * Maps meocloud server response into a mapping object
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} data    Meocloud mapped data
   * @param {Object} results server results data
   *
   * @return {void}
   */
  mapResponse(data, results, type) {
    data.authorized = results.authorized || false;

    if (data.authorized === false) {
      return;
    }


    let contents             = [];
    data.metadata            = results.metadata || {};
    data.metadata.path       = results.metadata.path || '/';
    data.metadata.split_path = [];
    data.metadata.contents   = results.metadata.contents || [];

    if (results.info) {
      data.account = results.info;
    }

    if (data.account.quota_info) {
        data.account.quota_info.used = data.account.quota_info.shared + data.account.quota_info.normal;
    }

    if (data.metadata.path !== '/') {
      let split      = results.metadata.path.split('/');
      let cumulative = '';
      split.shift();

      split.forEach((item) => {
        cumulative += '/' + item;
        data.metadata.split_path.push({
          name: item,
          path: cumulative
        });
      });
    }

    data.metadata.contents.forEach((item) => {
      if (type === 'folders' && item.is_dir === false) {
        return;
      }

      item.name = item.path.split('/').pop();

      contents.push(item);
    });

    data.metadata.contents = contents;
  }

  /**
   * Maps meocloud server response into a mapping object
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} results server results data
   *
   * @return {void}
   */
  mapUploads(results) {
    results.name = results.path.split('/').pop();
    return results;
  }
}
